import { defineStore } from 'pinia'
import axios from 'axios'
import { getResponse } from '@/composables/api'

export const useAppStore = defineStore({
   id: 'app-store',
   state: () => ({
      // App
      environment: 'production',
      maintenance: false,
      version: null,

      // Modal
      modal: null,

      // Feedback
      feedbackReferenceCode: ''
   }),
   actions: {
      updateMode(mode, version = null, stage = null) {

      if(version && stage) {
         this.version = version
         this.stage = stage

         if(! localStorage.getItem('cg_version')) localStorage.setItem('cg_version', version)
      }

        switch (mode) {
            case 'development':
               this.environment = 'development'
               this.maintenance = false
            break
            case 'maintenance':
               this.environment = 'production'
               this.maintenance = true
            break
            default:
               this.environment = 'production'
               this.maintenance = false
            break
         }
     },
     sendFeedback(data) {
      axios.post('feedback', data)
         .then(response => {
            this.feedbackReferenceCode = getResponse(response)
         })
     },
     resetFeedback() {
      this.feedbackReferenceCode = ''
     },
     /**
       * setModalEvent
       * Updates state with the latest modal event.
       * E.g. Modal opened, closed, etc.
       *
       * @param Object modalEvent
       * @param String routeName
       *
     */
     setModalEvent(modalEvent, routeName) {
       // Check event type
          const modalEventType = modalEvent.type === 'show.bs.modal' ? 'opened' : 'closed'
       // Build the modal object
       let modalObject = {
         id: modalEvent.target.id,
         event: modalEventType,
         size: modalEvent.target?.firstChild?.classList?.[1],
         route: routeName
       }

       // Assign the new object to state
       this.modal = modalObject
     },
   }
})